export default __webpack_public_path__ + "static/media/HERO_Roomboard_mobile.3c37012d.jpg";